import { useEffect } from 'react';
import { toast, type ToastContent } from 'react-toastify';
import { useNavigate } from 'react-router';
import { useFunnelStore } from '@/store/funnelStore';
import Toast from '@/components/ui/Toast';

export const useAccessDeniedToast = () => {
  const { accessDenied, setAccessDeniedMessage } = useFunnelStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (accessDenied.message && accessDenied.nextPath) {
      setTimeout(() => {
        toast.error(Toast as ToastContent, {
          toastId: 'access-denied-error-toast',
          position: 'top-center',
          className: 'border border-off-white',
          data: {
            title: 'Error Occurred',
            message: accessDenied.message,
          },
        });
      }, 800);
      navigate(accessDenied.nextPath);
      setAccessDeniedMessage({ message: '', nextPath: '' });
    }
  }, [accessDenied, setAccessDeniedMessage, navigate]);
};
